import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { TLLlmProvider } from '@/api/gen/tessera-backend-api.schemas';
import { LLMCostAdmin } from '@/components/features/admin/llm-costs/LLMCostAdmin';
import { ErrorBoundary, ErrorFallback } from '@/modus/ErrorBoundary';
import { userHasRole } from '@/utils/roles';

const llmCostSearchSchema = z.object({
  provider: z.nativeEnum(TLLlmProvider).optional().catch(undefined),
  // One-shot deep-link (from the chat picker's unpriced marker): opens the create form pre-filled
  // with this catalog model_id. Cleared from the URL once consumed.
  addCostModelId: z.string().uuid().optional().catch(undefined),
});

export const Route = createFileRoute('/_protected/usage_/llm-costs')({
  validateSearch: llmCostSearchSchema,
  beforeLoad: ({ context }) => {
    if (!userHasRole(context.user, 'llm-usage-dashboard-admin')) {
      throw redirect({ to: '/', replace: true });
    }
  },
  component: LLMCostAdminRoute,
});

function LLMCostAdminRoute() {
  return (
    <ErrorBoundary fallback={(error) => <ErrorFallback error={error} />}>
      <LLMCostAdmin />
    </ErrorBoundary>
  );
}
